// import lottie json files

export default function lottieAnimations() {
    const lottieContainer = document.querySelectorAll(".lottie-animation");

    // Base path setup for lottie files
    // Check if site is local, or if it's on WP Engine staging using contains
    let basePath = "";
    if (
        window.location.href.indexOf("belotero.local") > -1 ||
        window.location.href.indexOf("beloterostg.wpenginepowered.com") > -1
    ) {
        basePath = "/wp-content/themes/mtpress/lottie";
    } else {
        basePath = "/app/themes/mtpress/lottie";
    }

    // Lottie paths - relative to the root of the project
    const lottiePaths = [
        `${basePath}/infraorbitalHollows-after.json`,
        `${basePath}/marionetteLines-after.json`,
        `${basePath}/nasolabialFolds-after.json`,
        `${basePath}/oralCommissures-after.json`,
        `${basePath}/perioralLines-after.json`,
        `${basePath}/volumization-after.json`,
    ];

    let lottiePath = "";
    let lottieName = "";
    let lottieButton = "";

    if (lottieContainer) {
        lottieContainer.forEach(function (lottieContainer) {
            if (lottieContainer.classList.contains("infraorbital-hollows")) {
                lottiePath = lottiePaths[0];
                lottieName = "Infraorbital Hollows";
                lottieButton = document.querySelector(
                    ".infraorbital-hollows .lottie-button"
                );
            } else if (lottieContainer.classList.contains("marionette-lines")) {
                lottiePath = lottiePaths[1];
                lottieName = "Marionette Lines";
                lottieButton = document.querySelector(
                    ".marionette-lines .lottie-button"
                );
            } else if (lottieContainer.classList.contains("nasolabial-folds")) {
                lottiePath = lottiePaths[2];
                lottieName = "Nasolabial Folds";
                lottieButton = document.querySelector(
                    ".nasolabial-folds .lottie-button"
                );
            } else if (lottieContainer.classList.contains("oral-commissures")) {
                lottiePath = lottiePaths[3];
                lottieName = "Oral Commissures";
                lottieButton = document.querySelector(
                    ".oral-commissures .lottie-button"
                );
            } else if (lottieContainer.classList.contains("perioral-lines")) {
                lottiePath = lottiePaths[4];
                lottieName = "Perioral Lines";
                lottieButton = document.querySelector(
                    ".perioral-lines .lottie-button"
                );
            } else if (lottieContainer.classList.contains("volumization")) {
                lottiePath = lottiePaths[5];
                lottieName = "Volumization";
                lottieButton = document.querySelector(
                    ".volumization .lottie-button"
                );
            }

            let animation = bodymovin.loadAnimation({
                container: lottieContainer, // Required
                path: lottiePath, // Required
                renderer: "svg", // Required
                loop: false, // Optional
                autoplay: false, // Optional
                name: lottieName, // Name for future reference. Optional.
            });
            animation.setSpeed(0.5);

            // Reset lottie animation to start when button is clicked
            lottieButton.addEventListener("click", function () {
                animation.goToAndPlay(0, true);
            });

            // Play each lottie animation when in view, on window scroll
            window.addEventListener("scroll", function () {
                let lottieContainerTop =
                    lottieContainer.getBoundingClientRect().top;
                let lottieContainerBottom =
                    lottieContainer.getBoundingClientRect().bottom;

                if (
                    lottieContainerTop < window.innerHeight &&
                    lottieContainerBottom > 0
                ) {
                    animation.play();
                } else {
                    animation.pause();
                }
            });
        });
    }
}
